/**
 * Created by Julio Perez on 12/19/2016.
 */
import _ from 'underscore';

class IncomeWealthService {
    constructor(){

        let vm = this;

        vm.currentMax= 0;
        vm.forecastMax= 0;
        // vm.countrySegment = null;
        vm.toggleSelected = null;
        vm.latlngData = require('./data/country-latlng.json');
        vm.segmentedCountries = require('./data/data-segmented-countries.json');
        // vm.segmentedCountries = require('./data/map-per-cap-coffee.json');

        vm.getCountryLatLng=()=>{
            let countryLatLng = vm.latlngData
                .map(function(item){
                    return{
                        country: item.country,
                        latlng: item.latlng
                    }
                });

            return countryLatLng;
        }


        vm.getCountrySegment=(seg)=>{

            let countrySegment= vm.segmentedCountries
                .filter(function(item){
                    return item.segment === seg;
                })
                .map(function(item){
                    console.log("getCountrySegemetn:: ", item)
                    return item.metrics;
                }).shift();


            return countrySegment;
        }

        vm.getCurrentMax=(seg)=>{

            vm.currentMax= vm.segmentedCountries
                .filter(function(item){
                    return item.segment === seg;
                })
                .map(function(item){
                    return item.current_max;
                }).shift();

            return vm.currentMax;
        }

        vm.getForecastMax=(seg)=>{

            vm.forecastMax = vm.segmentedCountries
                .filter(function(item){
                    return item.segment === seg;
                })
                .map(function(item){
                    return item.forecast_max;
                }).shift();

            return vm.forecastMax;
        }


    }



}

export default angular
    .module('income-wealth.service', [])
    .service('incomeWealthService', IncomeWealthService)
    .name;


// WEBPACK FOOTER //
// ./src/app/services/income-wealth.service.js